import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7bce1fac")

_pushScopeId("data-v-7bce1fac")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "el-icon-user" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "el-icon-star-off" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "el-icon-map-location" }, null, -1)
const _hoisted_4 = { class: "user-info" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", {
  class: "el-icon-setting",
  style: {"margin-right":"15px"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-error" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_LocaleSwitcher = _resolveComponent("LocaleSwitcher")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_el_header = _resolveComponent("el-header")
  const _component_router_view = _resolveComponent("router-view")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")

  return (_openBlock(), _createBlock(_component_el_container, { direction: "horizontal" }, {
    default: _withId(() => [
      _createVNode(_component_el_scrollbar, {
        "view-style": "height: 100%;",
        style: `min-width: ${_ctx.isMobile || _ctx.isCollapsed ? 'auto' : '200px'}`,
        height: "100%"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_menu, {
            collapse: _ctx.isCollapsed,
            "default-openeds": ['dashboard'],
            router: true
          }, {
            default: _withId(() => [
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    route: { name: 'Users', params: { locale: _ctx.$i18n.locale } },
                    index: `${_ctx.$i18n.locale}/dashboard/users`
                  }, {
                    title: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("menu.users")), 1)
                    ]),
                    default: _withId(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["route", "index"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_menu_item, {
                route: { name: 'Games', params: { locale: _ctx.$i18n.locale } },
                index: `${_ctx.$i18n.locale}/dashboard/games`
              }, {
                title: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("menu.games")), 1)
                ]),
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["route", "index"]),
              _createVNode(_component_el_menu_item, {
                route: { name: 'Levels', params: { locale: _ctx.$i18n.locale } },
                index: `${_ctx.$i18n.locale}/dashboard/levels`
              }, {
                title: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("menu.levels")), 1)
                ]),
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["route", "index"])
            ]),
            _: 1
          }, 8, ["collapse"])
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_header, null, {
            default: _withId(() => [
              _createVNode("div", null, [
                _createVNode(_component_el_tooltip, {
                  class: "help-menu-close",
                  effect: "dark",
                  content: 
              _ctx.isCollapsed
                ? _ctx.$t('general.tooltips.menu.open')
                : _ctx.$t('general.tooltips.menu.close')
            ,
                  placement: "top-start"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      icon: _ctx.isCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left',
                      round: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_LocaleSwitcher, { small: "" }),
                _createVNode(_component_el_dropdown, null, {
                  dropdown: _withId(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_dropdown_item, { onClick: _ctx.signOut }, {
                          default: _withId(() => [
                            _hoisted_6,
                            _createTextVNode(_toDisplayString(_ctx.$t("general.actions.log_out")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode("span", null, _toDisplayString(_ctx.displayName), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})